'use strict';

exports.__esModule = true;

var _combineReducers;

var _redux = require('redux');

var _reducer = require('react-router-redux/lib/reducer');

var _subject = require('./subject/subject');

var _subject2 = _interopRequireDefault(_subject);

var _subjectCUList = require('./subject/subjectCUList');

var _subjectCUList2 = _interopRequireDefault(_subjectCUList);

var _subjectCUDetail = require('./subject/subjectCUDetail');

var _subjectCUDetail2 = _interopRequireDefault(_subjectCUDetail);

var _cuContact = require('./cu/cuContact');

var _cuContact2 = _interopRequireDefault(_cuContact);

var _majorHome = require('./major/majorHome');

var _majorHome2 = _interopRequireDefault(_majorHome);

var _culist = require('./cu/culist');

var _culist2 = _interopRequireDefault(_culist);

var _cuInfor = require('./cu/cuInfor');

var _cuInfor2 = _interopRequireDefault(_cuInfor);

var _cuNews = require('./cu/cuNews');

var _cuNews2 = _interopRequireDefault(_cuNews);

var _cuIntro = require('./cu/cuIntro');

var _cuIntro2 = _interopRequireDefault(_cuIntro);

var _cuSubject = require('./cu/cuSubject');

var _cuSubject2 = _interopRequireDefault(_cuSubject);

var _cumajorHome = require('./cumajor/cumajorHome');

var _cumajorHome2 = _interopRequireDefault(_cumajorHome);

var _cumajorIntro = require('./cumajor/cumajorIntro');

var _cumajorIntro2 = _interopRequireDefault(_cumajorIntro);

var _search = require('./search/search');

var _search2 = _interopRequireDefault(_search);

var _majorCUList = require('./major/majorCUList');

var _majorCUList2 = _interopRequireDefault(_majorCUList);

var _cumajorTypes = require('./major/cumajorTypes');

var _cumajorTypes2 = _interopRequireDefault(_cumajorTypes);

var _cumajorType = require('./major/cumajorType');

var _cumajorType2 = _interopRequireDefault(_cumajorType);

var _rankSubject = require('./rank/rankSubject');

var _rankSubject2 = _interopRequireDefault(_rankSubject);

var _rankMajor = require('./rank/rankMajor');

var _rankMajor2 = _interopRequireDefault(_rankMajor);

var _rankSchool = require('./rank/rankSchool');

var _rankSchool2 = _interopRequireDefault(_rankSchool);

var _article = require('./article/article');

var _article2 = _interopRequireDefault(_article);

var _rankShuangyi = require('./rank/rankShuangyi');

var _rankShuangyi2 = _interopRequireDefault(_rankShuangyi);

var _careerList = require('./career/careerList');

var _careerList2 = _interopRequireDefault(_careerList);

var _hiscoreYear = require('./hiscore/hiscoreYear');

var _hiscoreYear2 = _interopRequireDefault(_hiscoreYear);

var _hiscoreMajorList = require('./hiscore/hiscoreMajorList');

var _hiscoreMajorList2 = _interopRequireDefault(_hiscoreMajorList);

var _hiscoreMajorResult = require('./hiscore/hiscoreMajorResult');

var _hiscoreMajorResult2 = _interopRequireDefault(_hiscoreMajorResult);

var _home = require('./home/home');

var _home2 = _interopRequireDefault(_home);

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)((_combineReducers = {
    routing: _reducer.routerReducer,
    subject: _subject2.default,
    subjectCUList: _subjectCUList2.default,
    subjectCUDetail: _subjectCUDetail2.default,
    cuContact: _cuContact2.default,
    majorHome: _majorHome2.default,
    culist: _culist2.default,
    cuInfor: _cuInfor2.default,
    cuNews: _cuNews2.default,
    cuIntro: _cuIntro2.default,
    cuSubject: _cuSubject2.default,
    cumajorHome: _cumajorHome2.default,
    cumajorIntro: _cumajorIntro2.default,
    search: _search2.default,
    majorCUList: _majorCUList2.default,
    cumajorTypes: _cumajorTypes2.default,
    cumajorType: _cumajorType2.default,
    rankSubject: _rankSubject2.default,
    rankMajor: _rankMajor2.default,
    rankSchool: _rankSchool2.default,
    article: _article2.default,
    careerList: _careerList2.default
}, _combineReducers['careerList'] = _careerList2.default, _combineReducers.rankShuangyi = _rankShuangyi2.default, _combineReducers.hiscoreYear = _hiscoreYear2.default, _combineReducers.hiscoreMajorList = _hiscoreMajorList2.default, _combineReducers.hiscoreMajorResult = _hiscoreMajorResult2.default, _combineReducers.home = _home2.default, _combineReducers.auth = _auth2.default, _combineReducers));


//////////////////
// WEBPACK FOOTER
// ./src/reducers/index.js
// module id = 387
// module chunks = 0